// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"pop-over-list_popoverContainer__l2I4S","title":"pop-over-list_title__3jUwx","content":"pop-over-list_content__3FTMU","icon":"pop-over-list_icon__1zOB-"};